import React from 'react'
import classnames from 'classnames'
import { DolaThemes } from '../../styles/types'

interface BackDropCheckMarkProps {
  className?: string
  theme?: DolaThemes
}

const BackDropCheckMark: React.FC<BackDropCheckMarkProps> = ({
  className = '',
  theme = 'light',
}) => {
  return (
    <svg
      className={classnames('icon--backdrop-checkmark', {
        [className]: !!className,
      })}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5893 7.25603L8.33336 14.5119L4.41077 10.5894L5.58928 9.41085L8.33336 12.1549L14.4108 6.07751L15.5893 7.25603Z"
        fill={theme === 'light' ? 'white' : '#0B0B0B'}
      />
    </svg>
  )
}

export default BackDropCheckMark
